export default {
    data() {
        return {
            loadingSavedReplies: true,
            savedRepliesList: null,
            selectedSavedReply: null
        };
    },
    methods: {
        fetchSavedReplyOptions(emailId) {
            this.loadingSavedReplies = true;
            axios.get("/savedreplies/context/all", {
                params: {
                    email_id: emailId,
                    type: "email"
                }
            })
            .then((response) => {
                this.savedRepliesList = response.data;
                this.loadingSavedReplies = false;
            });
        }
    }
};
